import gql from 'graphql-tag';

export const IntegrationsDiscoveryIsAdmin = gql`
	query IntegrationsDiscoveryIsAdmin {
		isSiteAdmin
	}
`;
